import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from "../../utilities/Api";
import { ApiRequest } from "../../utilities/ApiRequest";
import * as ACTIONCONTANTS from "./ActionConstants";
import SampleViewData, {
  ISampleViewData,
} from "../../models/sample/SampleViewData";
import ISampleFormData from "../../models/Sample/SampleFormData";
import moment from "moment";
import { ReportProperties } from "../../models/sample/ReportProperties";
import IReportProperties from "../../models/sample/ReportProperties";
import IReportDetails from "../../models/sample/ReportDetails";
import { ReportDetails } from "../../models/sample/ReportDetails";
import { v4 as uuidv4 } from "uuid";
import i18next from "i18next";
import * as CONSTANTS from "../../utilities/Constants";
import axios from "axios";
import auth from "../../utilities/Auth";
class SampleActions {
  private readonly api: IApi;

  constructor() {
    this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
  }

  async getSampleStatus() {
    try {
      const request = new ApiRequest(
        "/Sample/SampleStatus",
        "",
        null,
        i18next.t("Sample not found.")
      );
      const result = await this.api.get(request);
      const payload = result.data;
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_STATUS,
        payload: {
          data: payload,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async getById(id: string) {
    try {
      const request = new ApiRequest(
        "/sample/" + id,
        "",
        null,
        i18next.t("Sample not found.")
      );
      const result = await this.api.get(request);

      const payload = this.convertResponseData(result.data);

      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_GET_BY_ID,
        payload: {
          sampleData: payload,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async getAll(
    isAll: boolean,
    page: number,
    pageSize: number,
    sort: string,
    order: string,
    filter: string
  ) {
    try {
      const request = new ApiRequest(
        `/sample/${isAll}/${page}/${pageSize}/${sort}/${order}/${filter}`,
        "",
        null,
        i18next.t("Unable to fetch samples.")
      );
      const result = await this.api.get(request);
      const payload = this.convertResponseListData(result.data);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_GET_ALL,
        payload: {
          sampleDataList: payload,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async getAllSampleData(
    isAll: boolean,
    page: number,
    pageSize: number,
    sort: string,
    order: string,
    filter: string,
    startDateTime: string,
    endDateTime: string
  ) {
    let samplePayload = this.prepareGetSampleDataPayload(isAll, page, pageSize, sort, order, filter, startDateTime, endDateTime)
    try {
      const request = new ApiRequest(
        `/sample/FilterSampleResult`,
        "",
        samplePayload,
        i18next.t("Unable to fetch samples.")
      );
      const result = await this.api.post(request);
      const payload = this.convertResponseListData(result.data);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_GET_ALL,
        payload: {
          sampleDataList: payload,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async postAll(payload: any, requestId: string) {
    try {
      const request = new ApiRequest(
        "/Sample/GetSampleDetails",
        requestId,
        payload,
        i18next.t("Unable to fetch samples.")
      );
      const result = await this.api.post(request);
      const payloads = this.convertResponseListData(result.data);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_POST_ALL,
        payload: {
          sampleDataList: payloads,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async post(data: ISampleFormData): Promise<void> {
    try {
      const payload: any = this.preparePostPayload(data);

      const request = new ApiRequest(
        "/sample/",
        data.requestId,
        payload,
        i18next.t("Sample created.")
      );
      const result = await this.api.post(request);

      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_SUBMIT,
        payload: {
          sampleId: result.data,
          message: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async copy(data: ISampleFormData): Promise<void> {
    try {
      const payload: any = this.prepareCopyPayload(data);

      const request = new ApiRequest(
        "/Sample/AddSampleCopy/",
        data.requestId,
        payload,
        i18next.t("Sample created.")
      );
      const result = await this.api.post(request);

      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_SUBMIT,
        payload: {
          sampleId: result.data,
          message: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async put(data: ISampleFormData): Promise<void> {
    try {
      const payload: any = this.preparePutPayload(data);

      const request = new ApiRequest(
        "/sample/",
        data.requestId,
        payload,
        i18next.t("Sample updated.")
      );
      const result = await this.api.put(request);

      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_SUBMIT,
        payload: {
          sampleId: data.id,
          message: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async delete(id: string, requestId: string): Promise<void> {
    try {
      const request = new ApiRequest(
        "/sample/" + id,
        requestId,
        undefined,
        i18next.t("Sample deleted")
      );
      const result = await this.api.delete(request);

      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_DELETE,
        payload: {
          reload: true,
          message: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async deleteMultiple(ids: Array<string>, requestId: string): Promise<void> {
    try {
      
      const deleteSamplesPayload = {
        ids: ids, // GUIDs as strings
        isCalledFromAutoDelete: false // Optional property
      };
          
       const authToken=  auth.getAccessToken();
      
       // Send DELETE request using Axios
       const response = await axios.delete(`${window.LMS.SAMPLE_API_URL}/Sample/DeleteMultipleSamples`, {
           headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${authToken}`
           },
           data: deleteSamplesPayload // Ensure 'data' property is used for DELETE requests
       });
           
        const result = response.data;

        LMSDispatcher.dispatch({
          type: ACTIONCONTANTS.SAMPLE_DELETE,
          payload: {
            reload: true,
            message: result.message,
          },
        });
      } catch (error) {
        throw error;
      }
  }

  async enable(id: string, requestId: string): Promise<void> {
    try {
      const request = new ApiRequest(
        "/sample/" + id + "/enable",
        requestId,
        undefined,
        i18next.t("Sample enabled")
      );
      const result = await this.api.patch(request);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_ENABLE,
        payload: {
          reload: true,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async disable(id: string, requestId: string): Promise<void> {
    try {
      const request = new ApiRequest(
        "/sample/" + id + "/disable",
        requestId,
        undefined,
        i18next.t("Sample disabled")
      );
      const result = await this.api.patch(request);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_DISABLE,
        payload: {
          reload: true,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async exportAll(id:string, sampleIds: string[], exportType: number, requestId: string, isExportXLS: any): Promise<void> {
    const payload = {
      id: id,
      sampleIds: sampleIds,
      exportType: exportType,
      isExportXLS: isExportXLS
    }
    try {
      const request = new ApiRequest(
        "/Sample/sample/export",
        requestId,
        payload,
        i18next.t("Sample exported")
      );
      const result = await this.api.post(request);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_EXPORT,
        payload: {
          downloadData: result.data,
          reload: true,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error.messages;
    }
  }

  async export(id: string): Promise<void> {
    try {
      const request = new ApiRequest(
        "/sample/" + id + "/sample/export",
        undefined,
        i18next.t("Sample exported")
      );
      const result = await this.api.download(request, id, "application/xml");
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_EXPORT,
        payload: {
          downloadData: result.data,
          reload: true,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async exportWithMeasurement(id: string): Promise<void> {
    try {
      const request = new ApiRequest(
        "/sample/" + id + "/sampleData/export",
        undefined,
        i18next.t("Sample exported")
      );
      const result = await this.api.download(request, id, "application/xml");
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_EXPORT,
        payload: {
          downloadData: result.data,
          reload: true,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error.messages;
    }
  }

  async exportWithMeasurementXLS(id: string[],requestId: string): Promise<void> {
    try {
      const request = new ApiRequest(
        "/sample/sampleData/exportXls",
        requestId,
        id,
        i18next.t("Sample exported XLS")
      );
      const result = await this.api.downloadPost(request, id, "");
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_EXPORT,
        payload: {
          downloadData: result.data,
          reload: true,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error.messages;
    }
  }

  async getValueReport(id: string, hasProduct:boolean = false) {
    try {
      const request = new ApiRequest(
        "/report/" + id + "/value/"+hasProduct,
        "",
        null,
        i18next.t("Unable to fetch measurement data.")
      );
      const result = await this.api.get(request);

      const data = this.convertReportData(result.data);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_VALUE_REPORT,
        payload: {
          reportData: data,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async checkinstrumentinuse(id: string[]) {
    try {
      let queryparams: string = "";
      id.map((item: any, index) => {
        if (id.length - 1 != index) {
          queryparams = queryparams + "ids=" + item + "&";
        } else {
          queryparams = queryparams + "ids=" + item;
        }
      });
      const request = new ApiRequest(
        `/Instrument/checkinstrumentinuse?${queryparams}`,
        "",
        null,
        i18next.t("Unable to fetch measurement data.")
      );
      const result = await this.api.get(request);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.CHECK_INSTRUMENT_IN_USE,
        payload: {
          instrumentData: result,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async getReport(sampleId: string, measurementId: string, productId: string) {
    try {
      let prodId = productId ? productId : CONSTANTS.DefaultGuid;
      const request = new ApiRequest(
        "/sample/" +
          sampleId +
          "/" +
          measurementId +
          "/" +
          prodId +
          "/properties",
        "",
        null,
        i18next.t("Unable to fetch measurement data.")
      );
      const result = await this.api.get(request);

      const data = this.convertReportData(result.data);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_VALUE_PROPERTIES,
        payload: {
          reportData: data,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async getMeasuredPropertyPosition(
    measurementId: string,
    instrumentId: string,
    propertyId: string,
    directionId: string
  ) {
    try {
      const request = new ApiRequest(
        "/Measurements/" +
          measurementId +
          "/" +
          instrumentId +
          "/measurementProperty" +
          "/" +
          propertyId +
          "/" +
          directionId +
          "/positions",
        "",
        null,
        i18next.t("Unable to fetch positions data.")
      );
      const result = await this.api.get(request);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_MEASURED_POSITIONS,
        payload: {
          data: result,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async getKeyedInPropertyPosition(
    measurementId: string,
    propertyId: string,
    directionId: string
  ) {
    try {
      const request = new ApiRequest(
        "/Measurements/" +
          measurementId +
          "/keyedinProperty/" +
          propertyId +
          "/" +
          directionId +
          "/positions",
        "",
        null,
        i18next.t("Unable to fetch positions data.")
      );
      const result = await this.api.get(request);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_KEYEDIN_POSITIONS,
        payload: {
          data: result,
          messages: result.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async getCalculatedPropertyPosition(
    measurementId: string,
    propertyId: string
  ) {
    try {
      const request = new ApiRequest(
        "/Measurements/" +
          measurementId +
          "/calculatedProperty/" +
          propertyId +
          "/positions",
        "",
        null,
        i18next.t("Unable to fetch positions data.")
      );
      const data = await this.api.get(request);
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_CALCULATED_POSITIONS,
        payload: {
          data: data,
          messages: data.message,
        },
      });
    } catch (error) {
      throw error;
    }
  }
  async pauseInstrumentMeasurement(
    sampleId: string,
    instruemntId: string,
    measurementId: string
  ) {
    try {
      const request = new ApiRequest(
        `/Measurements/pause/${sampleId}/sample/${measurementId}/measurement/${instruemntId}/instrument`,
        uuidv4(),
        "",
        i18next.t("Instrument Pausing.")
      );
      return this.api.post(request);
    } catch (error) {
      throw error;
    }
  }

  async reMeasureLastMeasurement(
    sampleId: string,
    instruemntId: string,
    directionId: string,
    measurementId: string,
    position: number,
    count: number,
    callback: () => void
  ) {
    try {
      this.pauseInstrumentMeasurement(
        sampleId,
        instruemntId,
        measurementId
      ).then(async () => {
        const payload: any = {
          sampleId,
          instrumentId: instruemntId,
          directionId,
          measurementId,
          position,
          count,
        };

        const request = new ApiRequest(
          "/Measurements/remeasureCount/",
          uuidv4(),
          payload,
          i18next.t("Instrument Remeasuring.")
        );
        const result = await this.api.post(request);

        LMSDispatcher.dispatch({
          type: ACTIONCONTANTS.SAMPLE_LAST_INSTRUMENT_REMASURE,
          payload: {
            sampleId: result.data,
            message: result.message,
          },
        });
        callback();
      });
    } catch (error) {
      throw error;
    }
  }
  async reMeasureLastMeasurementAll(
    sampleId: string,
    instruemntId: string,
    directionId: string[],
    measurementId: string,
    position: number,
    count: number[],
    isSetActive: boolean,
    callback: () => void
  ) {
    try {
      this.pauseInstrumentMeasurement(
        sampleId,
        instruemntId,
        measurementId
      ).then(async () => {
        const payload: any = {
          sampleId,
          instrumentId: instruemntId,
          directionId,
          measurementId,
          position,
          count,
          isSetActive
        };

        const request = new ApiRequest(
          "/Measurements/remeasureanypositioncount/",
          uuidv4(),
          payload,
          i18next.t("Instrument Remeasuring.")
        );
        const result = await this.api.post(request);

        LMSDispatcher.dispatch({
          type: ACTIONCONTANTS.SAMPLE_LAST_INSTRUMENT_REMASURE,
          payload: {
            sampleId: result.data,
            message: result.message,
          },
        });
        callback();
      });
    } catch (error) {
      throw error;
    }
  }

  // Skip count in position

  async skipCountinPosition(
    sampleId: string,
    instrumentId: string,
    measurementId: string,
    position: number,
    direction: string,
    count: number[],
    isSetActive:boolean,
  ) {
    try {
      this.pauseInstrumentMeasurement(
        sampleId,
        instrumentId,
        measurementId
      ).then(async () => {
        const payload: any = {
          sampleId,
          instrumentId,
          measurementId,
          position,
          directionId: [direction],
          count,
          isSetActive: isSetActive,
        };

        const request = new ApiRequest(
          "/Measurements/skipcountinPosition/",
          uuidv4(),
          payload,
          i18next.t("Instrument Position Skip Count.")
        );
        const result = await this.api.post(request);

        LMSDispatcher.dispatch({
          type: ACTIONCONTANTS.SAMPLE_SKIP_COUNT_IN_POSITION,
          payload: {
            sampleId: result.data,
            message: result.message,
          },
        });
      });
    } catch (error) {
      throw error;
    }
  }

  // End Position

  async endPosition(
    sampleId: string,
    instrumentId: string,
    measurementId: string,
    position: number,
    directionId: string[]
  ) {
    try {
      this.pauseInstrumentMeasurement(
        sampleId,
        instrumentId,
        measurementId
      ).then(async () => {
        const payload: any = {
          sampleId,
          instrumentId,
          measurementId,
          position,
          directionId: directionId,
        };

        const request = new ApiRequest(
          "/Measurements/endPosition/",
          uuidv4(),
          payload,
          i18next.t(`position ${position + 1} ${i18next.t("ended")}`)
        );
        const result = await this.api.post(request);

        LMSDispatcher.dispatch({
          type: ACTIONCONTANTS.SAMPLE_END_POSITION,
          payload: {
            sampleId: result.data,
            message: result.message,
          },
        });
      });
    } catch (error) {
      throw error;
    }
  }

  // Edit Sample Measurement

  async editSampleMeasurement(payload: any, requestId: any) {
    try {
        const request = new ApiRequest(`/Measurements/editSampleMeasurement`,requestId, payload, i18next.t("Internal server error!"));
        const data = await this.api.post(request);
        LMSDispatcher.dispatch({
            type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_EDIT,
            payload: {
                data: data
            }
        });
    } catch (error) {
        throw error;
    }
  }

  async getLatestSampleDetail() {
    try {
      const request = new ApiRequest(
        "/Sample/GetLatestSampleMesuredInfo",
        "",
        null,
        i18next.t("Sample not found.")
      );
      const result = await this.api.get(request);
      const payload = result.data;
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.SAMPLE_DETAIL_LATEST,
        payload: {
          data: payload,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  private preparePostPayload(data: ISampleFormData): any {
    let sampleDate = null;
    if (data.sampleDate) {
      let date = new Date();
      sampleDate = moment(date).utc().format("YYYY-MM-DD HH:mm");
    }
    return {
      name: data.name,
      description: data.description,
      productId: data.productId,
      sourceId: data.sourceId,
      orderId: data.orderId,
      setId: data.setId,
      sampleDate: sampleDate,
      testPlanId: data.testplanId ? data.testplanId : "",
      gradeId: data.gradeId ? data.gradeId : ""
    };
  }

  private prepareCopyPayload(data: ISampleFormData): any {
    let sampleDate = null;
    if (data.sampleDate) {
      let date = new Date(data.sampleDate);
      sampleDate = moment(date).utc().format("YYYY-MM-DD HH:mm");
    }
    return {
      name: data.name,
      description: data.description,
      productId: data.productId,
      sourceId: data.sourceId,
      testPlanId:data.testplanId,
      orderId: data.orderId,
      setId: data.setId,
      sampleDate: sampleDate,
      measurementId: data.measurementId,
      gradeId:data.gradeId, 
    };
  }

  private preparePutPayload(data: ISampleFormData): any {
    let sampleDate = null;
    if (data.sampleDate) {
      let date = new Date(data.sampleDate);
      sampleDate = moment(date).utc().format("YYYY-MM-DD HH:mm");
    }
    return {
      id: data.id,
      name: data.name,
      description: data.description,
      productId: data.productId,
      sourceId: data.sourceId,
      setId: data.setId,
      orderId: data.orderId,
      sampleDate: sampleDate,
      isEnabled: true,
      testPlanId: data.testplanId,
      gradeId: data.gradeId
    };
  }

  private convertResponseData(data: any): ISampleViewData {
    return new SampleViewData(
      data.id,
      data.name,
      data.description,
      data.isEnabled,
      data.sampleDate,
      data.setId,
      data.orderId,
      data.source,
      data.product,
      data.grade,
      data.testPlan,
      data.instruments,
      data.keyedInProperties,
      data.calculatedProperties,
      data.status,
      data.measurement,
      data.updatedOn
    );
  }

  private convertReportData(data: IReportProperties): IReportProperties {
    return new ReportProperties(
      data.calculatedProperties,
      data.keyedInProperties,
      data.measuredProperties
    );
  }

  private prepareGetSampleDataPayload(
    isAll:boolean, 
    page:number, 
    pageSize:number, 
    sort:string, 
    order:string, 
    filter:string,
    startDateTime: string,
    endDateTime: string
    ):any {
      let startDate = "";
      let endDate = "";
      if(startDateTime){
        startDate = moment.utc(startDateTime).format("YYYY-MM-DDTHH:mm:00")
      }
      if(endDateTime){
        endDate = moment.utc(endDateTime).format("YYYY-MM-DDTHH:mm:00")
      }
      return {
        isAll: isAll,
        page: page,
        pageSize: pageSize,
        sort: sort,
        order: order,
        startDateTime: startDate,
        endDateTime: endDate,
        filter: filter
      }
  }
  private convertResponseListData(data: any) {
    const result: ISampleViewData[] = [];
    if (data.contents) {
      data.contents.forEach(
        (element: {
          id: string;
          name: string;
          description: string;
          customId: number;
          type: { name: string };
          unit: string;
          decimals: number;
        }) => {
          result.push(this.convertResponseData(element));
        }
      );
    } else {
      data.forEach(
        (element: {
          id: string;
          name: string;
          description: string;
          customId: number;
          type: { name: string };
          unit: string;
          decimals: number;
        }) => {
          result.push(this.convertResponseData(element));
        }
      );
    }
    const tempResult = {
      result: data.contents ? result : result,
      currentPage: data.contents ? data.currentPage : 0,
      totalPages: data.contents ? data.totalPages : 0,
      totalRecords: data.contents ? data.totalRecords : 0,
    };
    return tempResult;
  }
}

const sampleActions = new SampleActions();
export default sampleActions;
